
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.854 4.354a.5.5 0 000-.708L1.672.464a.5.5 0 10-.708.708L3.793 4 .964 6.828a.5.5 0 10.708.708l3.182-3.182zM4 4.5h.5v-1H4v1z","fill":"#58697D"}})])
          )
        }
      }
    